import colors from "assets/theme/base/colors";

const { transparent } = colors;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
    },
  },
};
